import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    Box,
    CardActions,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { MapItLocalizedNumberTextField } from "src/components/common";

export default function ShippingCompanyConnectionInfoCard({
    connection,
    onUpdate,
    loading,
    isSuccess,
    error,
    handleChange
}) {
    const { t } = useTranslation()

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={t("Show in connections list")} />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={connection?.connectionView}
                            name="connectionView"
                            onChange={(event) => handleChange({ target: { name: "connectionView", value: event.target.checked } })}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    }
                    label={t("Show")}
                />
                <MapItLocalizedNumberTextField
                    label={t("Sort")}
                    name="connectionSort"
                    value={connection?.connectionSort || ''}
                    required={true}
                    handleChange={(event) => handleChange({ target: { name: "connectionSort", value: Number(event.target.value) } })}
                // error={validationErrors?.defaultKilograms}
                //min={1}
                />
            </CardContent>
            <Divider />
            <CardActions>
                {!!isSuccess && <Typography color="success.main">{t("Updated successfully")}</Typography>}
                {!!error && <Typography color="error">{t(error)}</Typography>}
                <Box mr="auto" />
                <LoadingButton
                    loading={loading}
                    onClick={() => onUpdate(connection)}
                    variant="contained"
                    sx={{ textTransform: 'none' }}>{t("Confirm")}
                </LoadingButton>
            </CardActions>
        </Card>
    );
};
